import { SVGProps } from 'react';
const InboxIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width={48}
        height={48}
        fill="none"
        viewBox="0 0 48 48"
    >
        <path
            fill="#001965"
            d="M28 14.271C28 12.333 26.427 11 24.04 11c-2.547 0-4 1.454-4.04 3.54h2.253c.054-.928.68-1.52 1.64-1.52.96 0 1.587.551 1.587 1.332 0 .78-.32 1.184-1.4 1.83-1.147.687-1.6 1.441-1.48 2.787v.458h2.2v-.444c0-.808.307-1.225 1.413-1.872 1.174-.7 1.787-1.575 1.787-2.84ZM25.32 23.385c0-.889-.72-1.616-1.6-1.616-.88 0-1.6.727-1.6 1.616 0 .888.72 1.615 1.6 1.615.88 0 1.6-.727 1.6-1.615Z"
        />
        <path
            stroke="#001965"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={3}
            d="M5 24h6.764c1.37 0 2.623.774 3.236 2a3.618 3.618 0 0 0 3.236 2h11.528c1.37 0 2.623-.774 3.236-2a3.618 3.618 0 0 1 3.236-2H43M17.933 8h12.134c2.154 0 3.23 0 4.181.328a6 6 0 0 1 2.242 1.385c.719.704 1.2 1.667 2.163 3.594l4.334 8.666c.377.756.566 1.134.7 1.53.118.352.204.714.255 1.081.058.415.058.837.058 1.682V30.4c0 3.36 0 5.04-.654 6.324a6 6 0 0 1-2.622 2.622C39.44 40 37.76 40 34.4 40H13.6c-3.36 0-5.04 0-6.324-.654a6 6 0 0 1-2.622-2.622C4 35.44 4 33.76 4 30.4v-4.134c0-.845 0-1.267.058-1.681a6 6 0 0 1 .255-1.082c.134-.396.323-.774.7-1.53l4.334-8.666c.963-1.927 1.444-2.89 2.163-3.594a6 6 0 0 1 2.242-1.385C14.702 8 15.779 8 17.933 8Z"
        />
    </svg>
);
export default InboxIcon;
